export default function BrandBanner() {
  return (
    <section className="relative overflow-hidden bg-amber-500 py-14 md:py-16">
      {/* Decorative circles */}
      <div className="absolute -left-16 top-1/2 -translate-y-1/2 w-64 h-64 bg-amber-400/40 rounded-full pointer-events-none"></div>
      <div className="absolute -right-8 top-1/2 -translate-y-1/2 w-48 h-48 bg-amber-600/30 rounded-full pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {/* Left text */}
          <div className="md:col-span-2">
            <p className="text-amber-100 text-xs font-bold uppercase tracking-[0.2em] mb-2">About HipoBuy 2026</p>
            <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-4">
              Your Trusted Destination for<br />
              Top-Quality Fashion in 2026
            </h2>
            <p className="text-amber-100 text-sm leading-relaxed max-w-xl">
              HipoBuy 2026 connects fashion-forward shoppers with verified sellers worldwide. We curate the best clothing, shoes, and accessories — all backed by our quality guarantee, fast HipoBuy shipping, and dedicated customer support.
            </p>
          </div>

          {/* Right stats */}
          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: "ri-user-smile-line", value: "50K+", label: "Customers" },
              { icon: "ri-global-line", value: "150+", label: "Countries" },
              { icon: "ri-store-2-line", value: "10K+", label: "Products" },
              { icon: "ri-star-line", value: "4.9★", label: "Rating" },
            ].map((s) => (
              <div key={s.label} className="bg-white/15 backdrop-blur-sm rounded-xl p-4 text-center">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                  <i className={`${s.icon} text-white text-xl`}></i>
                </div>
                <div className="text-xl font-black text-white">{s.value}</div>
                <div className="text-amber-100 text-xs mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
